import React, { useState } from 'react';
import { Button, Popconfirm } from 'antd';
import { SyncOutlined } from '@ant-design/icons';

interface ResetDraftButtonProps {
  onClick: () => void;
}

export const ResetDraftButton: React.FC<ResetDraftButtonProps> = ({ onClick }) => {
  return (
    <Popconfirm
      title="Bạn có chắc muốn xóa bản nháp?"
      okText="Xóa"
      cancelText="Hủy"
      okType="danger"
      onConfirm={onClick}
    >
      <Button
        className="text-xs ml-4"
        size="small"
        type="text"
        danger
        icon={<SyncOutlined />}
      >
        Đặt lại
      </Button>
    </Popconfirm>
  );
};
